import React from 'react';
import GuideUtilisationDrawer from './GuideUtilisationDrawer';

const GuideInterSiteFamilles = ({ isOpen, onClose }) => (
  <GuideUtilisationDrawer
    isOpen={isOpen}
    onClose={onClose}
    module="famillesNombreuses"
  />
);

export default GuideInterSiteFamilles;
